import React, { type HTMLAttributes, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Badges } from '@pkg/components';

import { Typography } from '../../../DesignSystem';

import {
    StyledPodItem,
    StyledPodStatus,
    StyledSearchListItemSpacer,
    StyledSearchListItemWrapper,
    StyledThumbnail,
} from './styles';

interface PodItemProps extends HTMLAttributes<HTMLDivElement> {
    name: string;
    thumbnail: string;
    type?: 'member' | 'owner';
    isPrivate: boolean;
    slug: string;
    focused?: boolean;
    onFocused?: (link: string) => void;
}

export function PodItem({ name, thumbnail, slug, type, isPrivate, focused, onFocused, ...rest }: PodItemProps) {
    const url = `/pods/${slug}`;

    useEffect(() => {
        focused && onFocused?.(url);
    }, [focused, url, onFocused]);

    return (
        <Link to={url}>
            <StyledSearchListItemWrapper {...rest} $focused={focused}>
                <StyledThumbnail src={thumbnail ?? '/assets/img/pod-icon-2.png'} />
                <StyledPodItem>
                    <Typography variant="h3" type="label" size={14} weight="700">
                        {name}
                    </Typography>
                    {(type || isPrivate) && (
                        <StyledPodStatus>
                            <Badges
                                isOwner={type === 'owner'}
                                hasMembership={type === 'member'}
                                privacy={isPrivate ? 'Private' : 'Public'}
                            />
                        </StyledPodStatus>
                    )}
                </StyledPodItem>
                <StyledSearchListItemSpacer />
            </StyledSearchListItemWrapper>
        </Link>
    );
}
